import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getTicketsList = (params: any, ticketId?: number) => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: `/tickets${ticketId ? `/${ticketId}` : ""}`,
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateTicketStatus = (ticketId: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/tickets/${ticketId}`,
    data: data, 
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTicketSenders = () => {
  const token = getAuthToken();
  return axios({
    method: "GET",
    url: "/tickets/senders",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
